(() => {
  if (window.__LF_SIZE_FILTER_V6__) return;
  window.__LF_SIZE_FILTER_V6__ = true;

  const SIZES = ['PP', 'P', 'M', 'G', 'GG', '2GG', '3GG', '4GG', '5GG'];
  const productCache = new Map();
  let applying = false;

  const clean = (v) => (v || '').replace(/\s+/g, ' ').trim();
  const norm = (v) => clean(v).toUpperCase();

  function isSizeDetail(detail) {
    const summary = detail?.querySelector('summary');
    const label = clean(summary?.textContent).toLowerCase();
    return label.includes('tamanho') || /^size\b/.test(label);
  }

  function hasSizeDetail(root) {
    return !!root && Array.from(root.querySelectorAll('details')).some(isSizeDetail);
  }

  function selectedSizes() {
    const params = new URLSearchParams(location.search);
    return (params.get('lf_size') || '')
      .split(',')
      .map(norm)
      .filter(Boolean);
  }

  function setSelectedSizes(values) {
    const url = new URL(location.href);
    if (values.length) {
      url.searchParams.set('lf_size', values.join(','));
      history.replaceState({}, '', url);
      syncChecks();
      applySizeFilter();
      return;
    }

    url.searchParams.delete('lf_size');
    location.assign(url.toString());
  }

  function toggleSize(value, checked) {
    const current = new Set(selectedSizes());
    checked ? current.add(norm(value)) : current.delete(norm(value));
    setSelectedSizes(SIZES.filter((s) => current.has(s)));
  }

  function makeCheckbox(size, mobile, index) {
    const li = document.createElement('li');
    li.className = mobile ? 'mobile-facets__item list-menu__item' : 'list-menu__item facets__item';

    const label = document.createElement('label');
    label.className = mobile ? 'mobile-facets__label' : 'facets__label facet-checkbox';

    const input = document.createElement('input');
    input.type = 'checkbox';
    input.value = size;
    input.dataset.lfSize = size;
    input.id = `LFSize-${mobile ? 'Mobile' : 'Desktop'}-${index}`;
    input.checked = selectedSizes().includes(size);
    if (mobile) input.className = 'mobile-facets__checkbox';
    input.addEventListener('input', (event) => event.stopPropagation());
    input.addEventListener('change', (event) => {
      event.stopPropagation();
      toggleSize(size, event.currentTarget.checked);
    });

    const text = document.createElement('span');
    text.className = mobile ? 'mobile-facets__label-text' : 'facet-checkbox__text';
    text.textContent = size;

    label.append(input, text);
    li.appendChild(label);
    return li;
  }

  function desktopFallback() {
    const details = document.createElement('details');
    details.className = 'disclosure-has-popup facets__disclosure js-filter';
    details.dataset.lfSizeFallback = 'desktop';
    details.innerHTML = `
      <summary class="facets__summary caption-large focus-offset">
        <div><span>Tamanho</span><span class="svg-wrapper">⌄</span></div>
      </summary>
      <div class="facets__display parent-display facets__display-vertical">
        <fieldset class="facets-wrap parent-wrap facets-wrap-vertical">
          <legend class="visually-hidden">Tamanho</legend>
          <ul class="facets__list list-unstyled" role="list"></ul>
        </fieldset>
      </div>`;
    const list = details.querySelector('ul');
    SIZES.forEach((size, i) => list.appendChild(makeCheckbox(size, false, i)));
    return details;
  }

  function mobileFallback() {
    const details = document.createElement('details');
    details.id = 'LF-Details-Mobile-Tamanho';
    details.className = 'mobile-facets__details js-filter';
    details.dataset.lfSizeFallback = 'mobile';
    details.dataset.index = 'mobile-lf-size';
    details.innerHTML = `
      <summary class="mobile-facets__summary focus-inset">
        <div>
          <span>Tamanho</span>
          <span class="mobile-facets__arrow" aria-hidden="true">→</span>
        </div>
      </summary>
      <div id="LF-FacetMobile-Tamanho" class="mobile-facets__submenu gradient" tabindex="-1">
        <button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">
          <span aria-hidden="true">←</span>
          <span>Tamanho</span>
        </button>
        <ul class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled" role="list"></ul>
      </div>`;

    const summary = details.querySelector('summary');
    const closeButton = details.querySelector('.mobile-facets__close-button');
    const submenu = details.querySelector('.mobile-facets__submenu');
    const list = details.querySelector('ul');
    SIZES.forEach((size, i) => list.appendChild(makeCheckbox(size, true, i)));

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      details.setAttribute('open', '');
      requestAnimationFrame(() => {
        details.classList.add('menu-opening');
        submenu?.focus({ preventScroll: true });
      });
    });

    const closeSubmenu = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      details.classList.remove('menu-opening');
      window.setTimeout(() => {
        details.removeAttribute('open');
        summary.focus();
      }, 250);
    };

    closeButton.addEventListener('click', closeSubmenu);
    details.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') closeSubmenu(event);
    });

    return details;
  }

  function injectFilters() {
    const desktop = document.getElementById('FacetsWrapperDesktop');
    const mobile = document.getElementById('FacetsWrapperMobile');

    if (desktop && !hasSizeDetail(desktop) && !desktop.querySelector('[data-lf-size-fallback="desktop"]')) {
      desktop.appendChild(desktopFallback());
    }

    if (mobile && !hasSizeDetail(mobile) && !mobile.querySelector('[data-lf-size-fallback="mobile"]')) {
      const node = mobileFallback();
      const footer = Array.from(mobile.children).find(
        (child) => child.classList?.contains('mobile-facets__footer')
      );
      if (footer) mobile.insertBefore(node, footer);
      else mobile.appendChild(node);
    }

    syncChecks();
  }

  function syncChecks() {
    const current = new Set(selectedSizes());
    document.querySelectorAll('input[data-lf-size]').forEach((input) => {
      input.checked = current.has(norm(input.dataset.lfSize));
    });
  }

  function productHandle(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    try {
      const pathname = new URL(link.href, location.origin).pathname;
      const match = pathname.match(/\/products\/([^/?#]+)/);
      return match?.[1] || null;
    } catch (_) {
      return null;
    }
  }

  async function productData(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    const promise = fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
    productCache.set(handle, promise);
    return promise;
  }

  function productSizes(product) {
    if (!product?.options || !product?.variants) return [];
    const index = product.options.findIndex((option) => {
      const name = clean(typeof option === 'string' ? option : option?.name).toLowerCase();
      return name.includes('tamanho') || name === 'size';
    });
    if (index < 0) return [];
    const values = new Set();
    product.variants.forEach((variant) => {
      const value = variant?.options?.[index];
      if (value) values.add(norm(value));
    });
    return [...values];
  }

  function pageCount(doc) {
    let max = 1;
    doc.querySelectorAll('.pagination__list a[href*="page="]').forEach((a) => {
      try {
        const p = Number(new URL(a.href, location.origin).searchParams.get('page'));
        if (p > max) max = p;
      } catch (_) {}
    });
    return max;
  }

  async function allCards() {
    const currentGrid = document.getElementById('product-grid');
    if (!currentGrid) return [];

    const parser = new DOMParser();
    const baseUrl = new URL(location.href);
    baseUrl.searchParams.delete('lf_size');
    baseUrl.searchParams.delete('page');

    let firstDoc;
    try {
      const html = await fetch(baseUrl.toString(), { credentials: 'same-origin' }).then((r) => r.text());
      firstDoc = parser.parseFromString(html, 'text/html');
    } catch (_) {
      return Array.from(currentGrid.children);
    }

    const docs = [firstDoc];
    const pages = pageCount(firstDoc);
    const tasks = [];
    for (let page = 2; page <= pages; page += 1) {
      const url = new URL(baseUrl);
      url.searchParams.set('page', String(page));
      tasks.push(
        fetch(url.toString(), { credentials: 'same-origin' })
          .then((r) => r.text())
          .then((html) => parser.parseFromString(html, 'text/html'))
          .catch(() => null)
      );
    }
    const extraDocs = await Promise.all(tasks);
    docs.push(...extraDocs.filter(Boolean));

    const cards = [];
    docs.forEach((doc) => {
      doc.querySelectorAll('#product-grid > .grid__item').forEach((card) => cards.push(card));
    });
    return cards;
  }

  function setLoading(on) {
    const collection = document.querySelector('#ProductGridContainer .collection');
    collection?.classList.toggle('loading', on);
  }

  function updateCount(count) {
    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const node = document.getElementById(id);
      if (node) node.textContent = `${count} ${count === 1 ? 'produto' : 'produtos'}`;
    });
  }

  async function applySizeFilter() {
    const wanted = selectedSizes();
    if (!wanted.length || applying) return;
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    applying = true;
    setLoading(true);
    try {
      const cards = await allCards();
      const matches = [];
      const batchSize = 24;

      for (let i = 0; i < cards.length; i += batchSize) {
        const batch = cards.slice(i, i + batchSize);
        const results = await Promise.all(
          batch.map(async (card) => {
            const handle = productHandle(card);
            const product = await productData(handle);
            const sizes = productSizes(product);
            return wanted.some((size) => sizes.includes(size)) ? card : null;
          })
        );
        matches.push(...results.filter(Boolean));
      }

      grid.replaceChildren(...matches.map((card) => document.importNode(card, true)));
      const pagination = document.querySelector('#ProductGridContainer .pagination-wrapper');
      if (pagination) pagination.style.display = 'none';
      updateCount(matches.length);
    } finally {
      setLoading(false);
      applying = false;
    }
  }

  function boot() {
    injectFilters();
    if (selectedSizes().length) applySizeFilter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      injectFilters();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();